import _ from "lodash";
import { checkFieldName, parseDate } from "../utils";
import { useEffect, useState } from "react";
import apiAgent from "../api/apiAgent";
import parse from "html-react-parser";
import {
  convertStringArrayToRange,
  getRangeAsLabels,
} from "./Forms/dateRangeComponent/DateRangeSelector";

export const DisplayValue = ({
  name,
  value,
  model,
  className,
  type,
  label,
}: {
  name: string;
  model?: string;
  value: any;
  type?: string;
  className?: string;
  label?: string;
}) => {
  const [displayName] = checkFieldName(name, model);

  const Display = (): JSX.Element => {
    return type === "string_array" ? (
      <div className="flex flex-wrap gap-x-2">
        {value?.map((v: string, index: number) => (
          <span key={index} className="py-0.5 px-1 bg-grayBg">
            {v.replaceAll('"', "")}
          </span>
        ))}
      </div>
    ) : type === "date_range_array" ? (
      <div className={className}>
        {value && value.length === 2
          ? getRangeAsLabels(convertStringArrayToRange(value))
          : `None`}
      </div>
    ) : type === "wysiwyg" && value ? (
      <div className={className}>{parse(value)}</div>
    ) : (name === "updatedAt" || name === "createdAt") && value ? (
      <div className={className}>{parseDate(value)}</div>
    ) : type === "number" || value ? (
      <div className={className}>{_.toString(value)}</div>
    ) : (
      <div className="opacity-30">-</div>
    );
  };

  return (
    <div className="flex text-sm font-medium">
      <div className="min-w-[10rem]">{label || displayName}:</div>
      <Display />
    </div>
  );
};

export const UserNameDisplay = ({ id }: { id: number }): JSX.Element => {
  const [username, setUsername] = useState<string>("unknown user");
  const [fetching, setFetching] = useState<boolean>(true);
  useEffect(() => {
    fetchUser();
  }, [id]);
  const fetchUser = async () => {
    try {
      setFetching(true);
      const response = await apiAgent.Users.getUsername(id);
      if (response.status === 200)
        setUsername(response.data?.username || "unknown user");
    } catch (err) {
    } finally {
      setFetching(false);
    }
  };
  return (
    <DisplayValue
      name="Last edited by"
      value={fetching ? "retrieving user..." : username}
    />
  );
};
